/**
 * How to have an account deleted. Public, for the same reason as the privacy policy: Google
 * Play's data safety form asks for a deletion-request URL a person can open without signing in.
 *
 * There is no self-service delete button, and deliberately so: accounts are created by a family
 * administrator, not by sign-up, and deleting one takes that person's photos with it. The
 * retention periods quoted here are the ones configured in infra.
 */

export function renderDeleteAccount() {
    document.getElementById('app').innerHTML = `
        <div class="container">
            <div class="section-header"><h1>Deleting your account</h1></div>

            <section class="form-section">
                <h2>How to ask</h2>
                <p>Email <a href="mailto:rob@shanksfamily.net?subject=Please%20delete%20my%20account">rob@shanksfamily.net</a>
                   from the address your account uses, or ask a family administrator directly. Say
                   whether you want your photos deleted as well, or passed to someone else in the
                   family first.</p>
                <p>Accounts here are created by an administrator rather than by signing up, so
                   deletion is handled the same way. You will get a reply confirming when it is done,
                   normally within a few days.</p>
            </section>

            <section class="form-section">
                <h2>What is deleted</h2>
                <ul>
                    <li>Your sign-in and your account details: name, email address, password and
                        two-factor setup.</li>
                    <li>Your photos and videos, with their captions and collections.</li>
                    <li>Every record of what you had shared, and who with.</li>
                    <li>Events you organised, including what guests added to them, if you ask for
                        those to go too.</li>
                </ul>
            </section>

            <section class="form-section">
                <h2>What stays</h2>
                <ul>
                    <li>A photo of yours that someone else copied into their own gallery belongs to
                        them, and stays. Ask them, or an administrator, if you want it removed.</li>
                    <li>Guest-book messages you left in someone else's event stay with that event
                        unless you ask for them to be taken out.</li>
                    <li>Database backups, for up to 7 days after deletion.</li>
                    <li>Server access logs, for up to 3 months. They record network addresses and
                        times, not your photos or messages.</li>
                </ul>
            </section>

            <section class="form-section">
                <h2>Deleting less than everything</h2>
                <p>You do not need an administrator to delete a single photo: open it in your gallery
                   and delete it there. You can turn off sharing on any photo at any time, and delete
                   a calendar entry or an event you created from its own page.</p>
            </section>

            <section class="form-section">
                <h2>More</h2>
                <p>See the <a href="/privacy" data-link>privacy policy</a> for what is stored and why.</p>
            </section>
        </div>`;
}
